/** @jsx jsx */
import { jsx } from '@emotion/react';

import requestUrlInfo from 'js/lib/requestUrlInfo';

import EntityPageCanonicalTag from 'bundles/seo-entity-page/components/EntityPageCanonicalTag';

type EntityPageCanonicalTagWrapperProps = {
  query: Record<string, string>;
  pathname: string;
};

const EntityPageCanonicalTagWrapper = ({ query, pathname }: EntityPageCanonicalTagWrapperProps) => {
  const hostname = requestUrlInfo().hostname;
  const queryEntries = Object.keys(query);

  if (queryEntries.length <= 6) {
    const searchParams = new URLSearchParams();
    if (query?.query) {
      searchParams.set('query', query.query);
    }

    const baseUrl = `https://${hostname}${pathname}`;
    const queryString = searchParams.toString();
    const canonicalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    return <EntityPageCanonicalTag canonicalUrl={canonicalUrl} />;
  }

  return null;
};

export default EntityPageCanonicalTagWrapper;
